import { initializeApp } from "firebase/app";
import { getMessaging, getToken } from "firebase/messaging";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { profileActions } from "../store";
import { accessTokenApi } from "./CallApi";

export const Firebase = () => {
  const { firebaseToken } = useSelector((state) => state.profile.profileData);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!firebaseToken) {
      getToken(getMessaging(), {
        vapidKey:
          "BO26BWbHnnoAetkoQdOa5UhHfBsXFVQRAPQFmYh2hyguXAbUhen9c_nDQCRcGWCURol_zgt27gfUYbse5zr13Ig",
      })
        .then((currentToken) => {
          console.log(currentToken);
          if (currentToken) {
            dispatch(
              profileActions.updateProfileData({ firebaseToken: currentToken })
            );
            accessTokenApi(currentToken).then((res) => {
              if (res.status) {
                dispatch(profileActions.updateProfileData({ ...res.data }));
              }
            });
          } else {
            // Show permission request UI
            console.log(
              "No registration token available. Request permission to generate one."
            );
          }
        })
        .catch((err) => {
          console.log("An error occurred while retrieving token. ", err);
        });
    }
  }, []);
  return null;
};

const firebaseConfig = {
  apiKey: "AIzaSyA_h7YC4S7tG2_OO7s5g_IE5i6hmporNbw",
  authDomain: "tribe-4ba44.firebaseapp.com",
  databaseURL: "https://tribe-4ba44.firebaseio.com",
  projectId: "tribe-4ba44",
  storageBucket: "tribe-4ba44.appspot.com",
  messagingSenderId: "686884969983",
  appId: "1:686884969983:web:1264c9aa86386ba3081bca",
  measurementId: "G-LMYSXKLWYF",
};
const app = initializeApp(firebaseConfig);
export const messaging = getMessaging(app);
